import getString from '@/helpers/GetStrings';

export default {
  data() {
    return {
      state: {
        initial: null,
        updated: null,
        whole: null,
      },
    };
  },
  methods: {
    getString,

    removeKeys(obj, keys) {
      for (const prop in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(prop)) {
          switch (typeof (obj[prop])) {
            case 'object':
              if (keys.indexOf(prop) > -1) {
                delete obj[prop];
              } else {
                this.removeKeys(obj[prop], keys);
              }
              break;
            default:
              if (keys.indexOf(prop) > -1) {
                delete obj[prop];
              }
              break;
          }
        }
      }
      return obj;
    },

    updateState(state) {
      if (state) {
        this.state.whole = JSON.stringify(state);
        // Remove guids and blocks (these will always be different)
        const formatted = this.removeKeys(JSON.parse(JSON.stringify(state)), ['guid']);

        if (this.state.initial === null) {
          this.state.initial = JSON.stringify(formatted);
        }

        this.state.updated = JSON.stringify(formatted);
      }

      // Remove the state (called after saving)
      if (state === false) {
        this.state = {
          initial: null,
          updated: null,
          whole: null,
        };
      }
    },
  },

  async beforeRouteLeave(to, from, next) {
    if (this.state.updated !== this.state.initial) {
      await this.$q.dialog({
        title: '',
        message: this.$store.state.stringsStore.language === 'nl' ? 'Jij hebt niet-opgeslagen wijzigingen, wil je deze wijzigingen tijdelijk opslaan?' : 'You have unsaved changes, would you like to temporarily save these changes?',
        ok: this.getString('dialog.confirm.ok'),
        cancel: this.getString('dialog.confirm.cancel'),
      }).then(() => {
        this.$store.dispatch('saveEditorState', JSON.parse(this.state.whole));
      }).catch(() => {
        if (this.$route.params.id) {
          this.axios.put(`${this.module}/${this.$route.params.id}/unlock`).finally(() => {
            // Call next regardless of the response (we dont want to be trapped here)
            next();
          });
        } else {
          next();
        }
      });
    }
    if (this.$route.params.id) {
      this.axios.put(`${this.module}/${this.$route.params.id}/unlock`).finally(() => {
        // Call next regardless of the response (we dont want to be trapped here)
        next();
      });
    } else {
      next();
    }
  },
};
